import { render } from "./LogoBar.vue?vue&type=template&id=5138d917&ts=true"
import script from "./LogoBar.vue?vue&type=script&lang=ts"
export * from "./LogoBar.vue?vue&type=script&lang=ts"

import "./LogoBar.vue?vue&type=style&index=0&id=5138d917&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__